import loadable from '@jupiter/plugin-runtime/loadable';
import PlatformRelativePaths from './paths';
var Homepage = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'homepage' */'../pages/homepage');
});
var AnnouncementsDetail = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'announcements' */'../pages/announcements-detail');
});
var ShopInfo = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'shop-info' */'../pages/shop-info');
});
var PersonalizationSettings = loadable(function () {
  return import(/* webpackPrefetch: true */ /* webpackChunkName: 'personalization-settings' */'../pages/personalization-settings');
});
export var personalizationSettingsRouteConfig = {
  path: PlatformRelativePaths.PERSONALIZATION_SETTINGS,
  component: PersonalizationSettings
};
var routesConfig = [{
  path: PlatformRelativePaths.HOMEPAGE,
  component: Homepage
}, {
  path: PlatformRelativePaths.ANNOUNCEMENT_DETAIL,
  component: AnnouncementsDetail
}, {
  path: PlatformRelativePaths.SHOP_INFO,
  component: ShopInfo
}];
export default routesConfig;